import { defineStore } from 'pinia';

import { RouterEnum, GridEnum } from '@interface/public';

export interface PublicStateInterface { // 平台状态
  width: number; // 宽
  height: number; // 高
  grid: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'; // 尺寸
  router: RouterEnum; // 路由
}

/**
 * 公共数据
 */
export default defineStore('public', {
  state: (): PublicStateInterface => { // 状态
    return {
      width: innerWidth,
      height: innerHeight,
      grid: 'xs',
      router: $Config.Page.default
    };
  },
  getters: { // 获取
    /**
     * 判断栅格是否符合条件
     * @return {Function} 回调
     */
    isGridMatch(): Function {
      return (match: string, grid: GridEnum) => {
        let isMatch = false;
        
        switch (match) {
          case '=':
            isMatch = this.width === grid;
            break;
          case '>':
            isMatch = this.width > grid;
            break;
          case '>=':
            isMatch = this.width >= grid;
            break;
          case '<':
            isMatch = this.width < grid;
            break;
          case '<=':
            isMatch = this.width <= grid;
            break;
        }
        
        return isMatch;
      };
    }
  },
  actions: { // 方法
    /**
     * 更新栅格
     */
    updateGrid(): void {
      let grid = 'xs';
      
      switch (true) {
        case this.width < $Enum.GridEnum.XS:
          grid = 'xs';
          break;
        case this.width >= $Enum.GridEnum.SM && this.width < $Enum.GridEnum.MD:
          grid = 'sm';
          break;
        case this.width >= $Enum.GridEnum.MD && this.width < $Enum.GridEnum.LG:
          grid = 'md';
          break;
        case this.width >= $Enum.GridEnum.LG && this.width < $Enum.GridEnum.XL:
          grid = 'lg';
          break;
        case this.width >= $Enum.GridEnum.XL && this.width < $Enum.GridEnum.XXL:
          grid = 'xl';
          break;
        case this.width >= $Enum.GridEnum.XXL && this.width < $Enum.GridEnum.XXXL:
          grid = 'xxl';
          break;
        case this.width >= $Enum.GridEnum.XXXL:
          grid = 'xxxl';
          break;
      }
      
      this.grid = grid;
    }
  }
});